import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { GeneralStatusComponent } from './general-status.component';
import { TranslateModule } from '../../../translate/translate.module';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule],
  declarations: [GeneralStatusComponent],
  exports: [GeneralStatusComponent]
})
export class GeneralStatusModule { }
